angular.module("ainapp")
    .controller("FPVMasterController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
        function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, window) {

             $scope.VoucherName = "Fund Payment Voucher"
            $scope.PageName = "Fund Payments";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {
                $scope.filter = {
                    Keyword: "",
                };
            }
            $scope.init();

            $scope.PrintSetting = {};
            MainService.PrintSettingsbyType("Fund Payment").then(function (response) {
                $scope.PrintSetting = response.data;
            });



            $scope.SalesSource = new kendo.data.DataSource({
                transport: {
                    read: function (o) {
                        o.data.Keyword = $scope.filter.Keyword;
                        MainService.FPVSInView(o.data).then(function (response) {
                            o.success(response.data);
                        }, function (err) {
                            o.success(false);
                            toastr.error($scope.NetworkErrorLan);
                        })
                    }
                },
                change: function (data) { },
                schema: {
                    data: "Data",
                    total: "Total",
                    model: {
                        id: "Id",
                        fields: {
                            Date: {
                                type: "date",
                            },
                            VoucherNumber: {
                                type: "string",
                            },
                            SubAccounts: {
                                type: "string",
                            },

                            "Account.Name": {
                                type: "string",
                            },

                            "Account.AccountCode": {
                                type: "string",
                            },
                            Total: {
                                type: "float",
                            },

                            CalcGrandTotal: {
                                type: "float",
                            },
                            "BaseCurrency.Name": {
                                type: "string",
                            },
                            CreatedDate: {
                                type: "date",
                            },
                            "CreatedBy.UserName": {
                                type: "string",
                            }

                        }
                    }
                },
                pageSize: 10,
                serverPaging: true,
                serverSorting: true,
                serverFiltering: true,
            });

            $scope.SalesFactory = {
                toolbar: ["excel"],
                stretch: true,
                selectable: true,
                groupable: false,
                height: 550,
                sortable: true,
                resizable: true,
                dataSource: $scope.SalesSource,
                pageable: true,
                pageable: {
                    input: false,
                    refresh: true,
                    pageSizes: true,
                    info: true,
                },
                filterable: true,

                columns: [


                    {
                        field: "Date",
                        template: "#= kendo.toString(kendo.parseDate(Date, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Date",
                        headerTemplate: "{{LanguageData.date}}",
                    },
                    {
                        field: "VoucherNumber",
                        title: "Voucher Number",
                        headerTemplate: "{{LanguageData.vouchernumber}}",
                    },
                    {
                        field: "Account.AccountCode",
                        title: "Account",
                        headerTemplate: "{{LanguageData.account}}",
                    },
                    {
                        field: "Account.Name",
                        title: "Account Name",
                        headerTemplate: "{{LanguageData.account_name}}",
                    },
                    {
                        field: "SubAccounts",
                        title: "Sub Accounts",
                    },

                    {
                        field: "Total",
                        title: "Total",
                        headerTemplate: "{{LanguageData.Total}}",
                        template: "<div style='text-align: right'>#=kendo.toString(Total, 'n')#</div>",

                    },
                    {
                        field: "BaseCurrency.Name",
                        title: "Currency",
                        headerTemplate: "{{LanguageData.Currency}}",
                    },


                    {
                        field: "CalcGrandTotal",
                        title: "Calc Total",
                        template: "<div style='text-align: right'>#=kendo.toString(CalcGrandTotal, 'n')#</div>",

                    },

                    {
                        field: "CreatedDate",
                        template: "#= kendo.toString(kendo.parseDate(CreatedDate, 'yyyy-MM-dd'), 'dd/MM/yyyy') #",
                        title: "Created Date"
                    },

                    {
                        field: "CreatedBy.UserName",
                        title: "Created By"
                    },
                    {
                        title: "Options",
                        headerTemplate: "{{LanguageData.Options}}  ",
                        template: `<div ng-include="'templates/common/viewButtons.html'" ng-init="IsPayRec=true"></div>`,
                        width: '140px'
                    },


                ],
            };


            $scope.Edit = function (data) {
                $state.go("editFPVMaster", {
                    VoucherId: data.Id
                })
            };

            $scope.openPrintModal = function (data) {

                $scope.SelectedDataForPrint = data;

                if ($scope.PrintSetting.length > 1) {
                    $('#printModal').modal('show');
                } else if ($scope.PrintSetting.length == 1) {
                    $scope.PrintInvoice(data.Id, $scope.PrintSetting[0].FileName);
                } else {
                    $scope.PrintInvoice(data.Id, $scope.VoucherName);
                }

            };
            
            $scope.refresh = function () {
                $scope.filter = {
                    Keyword: "",
                    Type: "",
                };
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            };

            $scope.SearchKendo = function () {
                $("#Sales-grid").data("kendoGrid").dataSource.read();
            }


            $scope.SelectedDataForDelete = {};
            $scope.Delete = function (data) {

                if (!$scope.PageAccessInfo.IsRemove) {
                    toastr.info("You Dont Have Access To Delete Data, Please Contact Admin");
                } else {
                    $scope.SelectedDataForDelete = data;
                    $('#deleteModal').modal('show');
                }
            }

            $scope.deleteWithConfirm = function () {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteFPV($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response.data.Message == "Success") {
                        toastr.success("Success");
                        $scope.refresh();
                        $('#deleteModal').modal('hide');
                    } else {
                        toastr.warning(response.data.Message);
                    }
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.Print = function (data) {
                $scope.load = true;
                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });
                MainService.DeleteFPV($scope.SelectedDataForDelete.Id).then(function (response) {
                    if (response) {
                        $scope.load = false;
                        toastr.success("Success");
                        $scope.refresh();
                    }
                    $.LoadingOverlay("hide");
                }, function () {
                    toastr.error("NetworkError");
                    $scope.working = false;
                    $scope.load = false;
                    $.LoadingOverlay("hide");
                })

            }

            $scope.View = function (data) {
                if (!$scope.PageAccessInfo.IsView) {
                    toastr.info("You Dont Have Access To View Data, Please Contact Admin");
                } else {
                    // $state.go("viewFPVMaster", {
                    //     VoucherId: data.Id
                    // })

                    var url = $state.href('viewFPVMaster', {
                        VoucherId: data.Id
                    });
                    window.open(url, '_blank');
                }
            }

        }])
